import { render, staticRenderFns } from "./BaseCropper.vue?vue&type=template&id=38ad636d&scoped=true&"
import script from "./BaseCropper.vue?vue&type=script&lang=js&"
export * from "./BaseCropper.vue?vue&type=script&lang=js&"
import style0 from "./BaseCropper.vue?vue&type=style&index=0&id=38ad636d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad636d",
  null
  
)

export default component.exports